module.exports = __webpack_public_path__ + "static/media/hw_sa_11.afd23672.flv";